import buildStdDbModelActions from './std-db-model-actions';

export default buildStdDbModelActions('project-users');
